if (!customElements.get('product-tabs')) {
	customElements.define(
		'product-tabs',
		class ProductTabs extends HTMLElement {
			constructor() {
				super();

				this.tab = this.querySelectorAll('.tab-title');
				this.tabContent = this.querySelectorAll('.tab-content');
				this.link = this.querySelectorAll('.toggleLink');
				this.toggleContent = this.querySelectorAll('.toggle-content');

				if (window.innerWidth <= 749) {
					this.activeItem = this.querySelector('.toggle-content.is-active');
					this.activeItem.style.maxHeight = this.activeItem.querySelector('.toggle-content-inner').offsetHeight + 'px';
				}
				for (let i = 0; i < this.tab.length; i++) {
					this.tab[i].addEventListener('click', this.tabActive.bind(this));
				}

				for (let i = 0; i < this.link.length; i++) {
					this.link[i].addEventListener('click', this.tabToggle.bind(this));
				}
			}

			tabActive(event){
				event.preventDefault();
				event.stopPropagation();

				var $this = event.target,
					id = $this.getAttribute('href').replace('#', '');

				if(!$this.classList.contains('is-open')) {
					this.tab.forEach((element, index) => {
						element.classList.remove('is-open');
					});

					$this.classList.add('is-open');

					this.tabContent.forEach((element, index) => {
						if(element.getAttribute('id') == id){
							element.classList.add('is-active');
						} else {
							element.classList.remove('is-active');
						}
					});
				}
			}

			tabToggle(event){
				event.preventDefault();
				event.stopPropagation();

				var $this = event.currentTarget,
					id = $this.getAttribute('href').replace('#', ''),
					$thisContent = $this.parentNode.nextElementSibling,
					$thisContentInner = $this.parentNode.nextElementSibling.querySelector('.toggle-content-inner'),
					$height = $thisContentInner.offsetHeight + 'px',
					$duration =  Math.round(($thisContentInner.offsetHeight / 600),0),
					$oldActive = event.currentTarget;

					if ($duration > 1) {
						var $transitionDurationUp = $duration / 4;
						var $transitionDurationDown = $duration / 2;
					} else {
						var $transitionDurationUp = ($duration * 4) / 10;
						var $transitionDurationDown = ($duration * 4) / 10;
					}

				if (window.innerWidth <= 749) {
					if ($this.classList.contains('is-open')) {
						$this.classList.remove('is-open');
						$thisContent.classList.remove('is-active');
						$thisContent.style.maxHeight = '0';
						$thisContent.style.transitionDuration = $transitionDurationUp + 's';
					} else {
						this.link.forEach((element, index) => {
							if (element.classList.contains('is-open')){
								$oldActive = element;
							}
							element.classList.remove('is-open');
						});
						this.toggleContent.forEach((element, index) => {
							element.classList.remove('is-active');
							element.removeAttribute('style');
						});
						$this.classList.add('is-open');
						$thisContent.classList.add('is-active');
						$thisContent.style.maxHeight = $height;
						$thisContent.style.transitionDuration = $transitionDurationDown + 's';
						if ($this.dataset.tabIndex > $oldActive.dataset.tabIndex) {
							$oldActive?.scrollIntoView({ behavior: 'smooth', block: 'start' });
						}
					}
				}
			}
		}
	);
}